import { render, staticRenderFns } from "./DoTestPage.vue?vue&type=template&id=31f2fc77&scoped=true&"
import script from "./DoTestPage.vue?vue&type=script&lang=js&"
export * from "./DoTestPage.vue?vue&type=script&lang=js&"
import style0 from "./DoTestPage.vue?vue&type=style&index=0&id=31f2fc77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f2fc77",
  null
  
)

export default component.exports